export default {

  init() {

  },
  finalize() {
    jQuery('table[name=assessment-form-table]').each(function() {

      // add class to checked inputs
      if(jQuery("input.likert-choice", this).is(":checked"))  {
        jQuery("td input:checked", this).parent().addClass("mychoice");
      }

      // add a selected class to the parent list item
      jQuery("input.likert-choice", this).change(function() {
        if(jQuery(this).is(":checked"))  {
          jQuery(this).parent().parent().find(".mychoice").removeClass("mychoice");
          jQuery(this).parent().addClass("mychoice");
        }
      });

      // Cater for sloppy pointers
      jQuery('td.choice', this).on('click', function(e) {
        if (jQuery(e.target).is('input:radio')) {
          e.stopPropagation();
          // Only remove the error if the radio button itself is clicked!
          jQuery('input:radio', this).parent().parent().find(".invalid-feedback").hide(); // Hide error
        } else {
          if (jQuery('input:radio', this).prop('checked') === true) {
            return false;
            // Don't do anything if it's already checked!
          }
          if (jQuery('input:radio', this).hasClass( 'locked')) {
            return false;
            // Don't do anything if it's disabled!
          }
          jQuery('input:radio', this).prop('checked', true); // Check the radio
          jQuery('input:radio', this).parent().parent().find(".mychoice").removeClass("mychoice"); // Remove class
          jQuery('input:radio', this).parent().parent().find(".invalid-feedback").hide(); // Hide error
          jQuery( "td input:checked" ).parent().addClass( "mychoice" ); // Set the input class
        }
      });

    });



  }
};


// WEBPACK FOOTER //
// ./scripts/routes/feedback-kt.js